export default {
  path: "/login",
  name: "login",
  component: () => import("../pages/index.vue")
};
